import { countdownIntlIds } from './countdown.ids';

export const countdownLangPtBr = {
  [countdownIntlIds.progressive.label]: '{timer} de atraso',
  [countdownIntlIds.regressive.label]: '{timer} restantes',
};
